/**
 * 区分 bankAccountType（customers.bank_account_type）
 * 出典：仕様書 7 章サーバー側の入力チェック
 */
export const BANK_ACCOUNT_TYPE_VALUES = ['ordinary', 'checking'] as const;

export type BankAccountType = (typeof BANK_ACCOUNT_TYPE_VALUES)[number];

export const BANK_ACCOUNT_TYPE_LABELS: Readonly<Record<BankAccountType, string>> = {
  ordinary: '普通',
  checking: '当座',
};
